import { type SyntheticEvent } from "react";
import { useNavigate } from "react-router-dom";

import { Tab, Tabs } from "ui/tabs";

import SmsSimulatorRoutes from "containers/sms-simulator/sms-simulator.routes";

import { SmsSimulatorProvider } from "containers/sms-simulator/sms-simulator.context";

import { TabItem, useTab } from "hooks/use-tab";
import { getSmsSimulatorTabRoute } from "containers/sms-simulator/sms-simulator.helpers";

import { SMS_SIMULATOR_STYLES } from "containers/sms-simulator/sms-simulator.styles";

const SmsSimulator = () => {
  return (
    <SmsSimulatorProvider>
      <SmsSimulatorContent />
    </SmsSimulatorProvider>
  );
};

const SMS_SIMULATOR_PAGE_TABS: TabItem[] = [
  { name: "Rules", path: "rules" },
  { name: "Personas", path: "personas" },
  { name: "Simulator", path: "simulator" },
] as const;

const SmsSimulatorContent = () => {
  const navigate = useNavigate();

  const currentTab = useTab(SMS_SIMULATOR_PAGE_TABS, "Rules");

  const handleTabChange = (_event: SyntheticEvent, tabName: string) => {
    const tab = getSmsSimulatorTabRoute(tabName);
    navigate(tab, { replace: true });
  };

  return (
    <>
      <div className="flex flex-col items-start bg-gray-200 px-8 pt-4">
        <div className="flex items-center mt-2 mb-3">
          <h1 className={SMS_SIMULATOR_STYLES.heading}>SMS Simulator</h1>
        </div>
        <Tabs
          appearance="bookmark"
          aria-label="sms-simulator-tabs-toggle"
          value={currentTab}
          onChange={handleTabChange}>
          {SMS_SIMULATOR_PAGE_TABS.map(({ name }) => (
            <Tab key={name} value={name} label={name} />
          ))}
        </Tabs>
      </div>
      <SmsSimulatorRoutes />
    </>
  );
};

export default SmsSimulator;
